import { useNavigate } from "react-router-dom";
import { BRAND_LOGO_URL, BRAND_NAME } from "@/constants/brand";
import { useBrandSettings } from "@/hooks/useBrandSettings";

const footerLinks = [
  {
    title: "Notícias",
    links: [
      { label: "Últimas Notícias", path: "/noticias" },
      { label: "Brasileirão", path: "/brasileirao" },
      { label: "Internacional", path: "/internacional" },
      { label: "Mercado da Bola", path: "/mercado-da-bola" },
    ],
  },
  {
    title: "Competições",
    links: [
      { label: "Brasileirão", path: "/brasileirao" },
      { label: "Internacional", path: "/internacional" },
      { label: "Copa do Brasil", path: "/jogos" },
      { label: "Jogos", path: "/jogos" },
    ],
  },
  {
    title: "Botafogo TV",
    links: [
      { label: "Vídeos", path: "/botafogo-tv" },
      { label: "Ao Vivo", path: "/ao-vivo" },
      { label: "Entrevistas", path: "/botafogo-tv" },
      { label: "Melhores Momentos", path: "/botafogo-tv" },
    ],
  },
  {
    title: "Institucional",
    links: [
      { label: "Sobre", path: "/sobre" },
      { label: "Contato", path: "/contato" },
      { label: "Política de Privacidade", path: "/politica-de-privacidade" },
      { label: "Termos de Uso", path: "/termos-de-uso" },
    ],
  },
];

const socialLinks = [
  { icon: "ri-whatsapp-line", label: "WhatsApp", url: "#" },
  { icon: "ri-facebook-circle-line", label: "Facebook", url: "#" },
  { icon: "ri-twitter-x-line", label: "X", url: "#" },
  { icon: "ri-instagram-line", label: "Instagram", url: "#" },
  { icon: "ri-youtube-line", label: "YouTube", url: "#" },
  { icon: "ri-telegram-line", label: "Telegram", url: "#" },
];

export default function Footer() {
  const navigate = useNavigate();
  const { logoSize } = useBrandSettings();
  const footerLogoSize = Math.max(48, Math.round(logoSize * 0.85));

  return (
    <footer className="bg-alvinegro-dark text-white">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 md:gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img
                src={BRAND_LOGO_URL}
                alt={BRAND_NAME}
                className="object-contain"
                style={{ width: footerLogoSize, height: footerLogoSize }}
              />
              <div>
                <h2 className="font-serif font-bold text-xl">{BRAND_NAME}</h2>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Tudo sobre o Glorioso, em um só lugar.
              <br />
              Notícias, jogos, vídeos e muito mais sobre o Botafogo.
            </p>
            {/* Newsletter */}
            <div className="flex items-center gap-2">
              <input
                type="email"
                placeholder="Seu e-mail"
                className="flex-1 px-4 py-2.5 rounded-full bg-white/10 border border-white/20 text-white text-sm placeholder:text-white/50 focus:outline-none focus:border-white/50"
              />
              <button className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:bg-white/90 transition-colors cursor-pointer">
                <i className="ri-notification-3-line text-alvinegro-black"></i>
              </button>
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold text-sm mb-4 text-white">{section.title}</h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <button
                      onClick={() => navigate(link.path)}
                      className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-xs">
              © 2026 Central Alvinegra. Todos os direitos reservados.
            </p>

            {/* Social Icons */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 rounded-lg border border-white/20 flex items-center justify-center text-white/70 hover:text-white hover:border-white/50 transition-colors"
                >
                  <i className={`${social.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>

            <div className="flex items-center gap-4 text-xs text-white/60">
              <button onClick={() => navigate("/politica-de-privacidade")} className="hover:text-white transition-colors cursor-pointer">
                Política de Privacidade
              </button>
              <button onClick={() => navigate("/termos-de-uso")} className="hover:text-white transition-colors cursor-pointer">
                Termos de Uso
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
